module.exports = __webpack_public_path__ + "img/swiper5.cc3a4d8d.png";